<div class="component-box" *ngIf="isSearchVisible">
  <div class="info-banner" *ngIf="showCompensationGatingInfo">
    <mat-icon class="info-banner__icon">info</mat-icon>
    <div class="info-banner__content">
      <div class="info-banner__title">Restricted company list</div>
      <ul class="info-banner__list">
        <li>Only companies whose <strong>Corporate Governance</strong> has been marked as finished are shown.</li>
        <li>USA companies that have a <strong>Form 20-F</strong> report in their Corporate Governance collection are excluded.</li>
      </ul>
    </div>
  </div>
  <div class="info-banner" *ngIf="showCsrGatingInfo">
    <mat-icon class="info-banner__icon">info</mat-icon>
    <div class="info-banner__content">
      <div class="info-banner__title">Restricted company list</div>
      <ul class="info-banner__list">
        <li>Only companies whose <strong>capitalization</strong> (Large, Medium or Small) matches the country/year flags configured in <strong>ESG Country Capitalization</strong> are shown.</li>
        <li>Eligibility is evaluated across all years in the table — a company qualifies if it matches in at least one (country, year) pair.</li>
      </ul>
    </div>
  </div>
  <div class="info-banner" *ngIf="showVotingResultsGatingInfo">
    <mat-icon class="info-banner__icon">info</mat-icon>
    <div class="info-banner__content">
      <div class="info-banner__title">Restricted company list</div>
      <ul class="info-banner__list">
        <li>USA companies that have a <strong>Form 20-F</strong> report in their Corporate Governance collection are excluded.</li>
      </ul>
    </div>
  </div>
  <form (ngSubmit)="onSearch()" class="search-form">
    <div class="search-fields">
      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showMeasurement">
        <mat-label>Measurement</mat-label>
        <mat-select [(ngModel)]="searchForm.measurement" name="measurement" placeholder="Measurement">
          <mat-option *ngFor="let measurement of measurements" [value]="measurement">
            {{ measurement }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.measurement" type="button" mat-icon-button matSuffix (click)="searchForm.measurement = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showCountry">
        <mat-label>Country</mat-label>
        <mat-select [(ngModel)]="searchForm.country" name="country" placeholder="Country">
          <mat-option *ngFor="let country of countries$ | async" [value]="country.id">
            {{ country.name }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.country" type="button" mat-icon-button matSuffix (click)="searchForm.country = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showListingStatus">
        <mat-label>Listing Status</mat-label>
        <mat-select [(ngModel)]="searchForm.listingStatus" name="listingStatus" placeholder="Listing Status">
          <mat-option value="all">All</mat-option>
          <mat-option value="primary">Primary listed</mat-option>
          <mat-option value="secondary">Secondary listed</mat-option>
        </mat-select>
        <button *ngIf="searchForm.listingStatus" type="button" mat-icon-button matSuffix (click)="searchForm.listingStatus = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showIndex">
        <mat-label>Index</mat-label>
        <mat-select [(ngModel)]="searchForm.index" name="index" placeholder="Index">
          <mat-option *ngFor="let index of indexes$ | async" [value]="index.id">
            {{ index.name }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.index" type="button" mat-icon-button matSuffix (click)="searchForm.index = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showCode">
        <mat-label>Internal ID</mat-label>
        <input matInput [(ngModel)]="searchForm.code" name="code" placeholder="Search by internal ID">
      </mat-form-field>
      <mat-form-field appearance="fill" *ngIf="fieldsConfig.showName">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="searchForm.name" name="name" placeholder="Search by company name">
      </mat-form-field>
      <app-tree-select
        *ngIf="fieldsConfig.showIndustry"
        [data]="(industries$ | async) ?? []"
        (selectionChange)="onSelectionChange($event)"
        label="Industry"
        placeholder="Industry">
      </app-tree-select>
      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showUnitaryDual">
        <mat-label>Unitary/Dual</mat-label>
        <mat-select [(ngModel)]="searchForm.unitaryDual" name="unitaryDual" placeholder="Unitary/Dual">
          <mat-option [value]="0">Unitary</mat-option>
          <mat-option [value]="1">Dual</mat-option>
        </mat-select>
        <button *ngIf="searchForm.unitaryDual !== undefined && searchForm.unitaryDual !== null" type="button" mat-icon-button matSuffix (click)="searchForm.unitaryDual = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showCapitalization">
        <mat-label>Capitalization</mat-label>
        <mat-select [(ngModel)]="searchForm.capitalization" name="capitalization" placeholder="Capitalization">
          <mat-option [value]="3">Large</mat-option>
          <mat-option [value]="2">Medium</mat-option>
          <mat-option [value]="1">Small</mat-option>
          <mat-option [value]="0">Unknown</mat-option>
        </mat-select>
        <button *ngIf="searchForm.capitalization !== undefined && searchForm.capitalization !== null" type="button" mat-icon-button matSuffix (click)="searchForm.capitalization = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showIsEmpty">
        <mat-label>Is Empty</mat-label>
        <mat-select [(ngModel)]="searchForm.isEmpty" name="isEmpty" placeholder="Is Empty">
          <mat-option value="Investor name">Investor name</mat-option>
          <mat-option value="Investor mail">Investor mail</mat-option>
          <mat-option value="Investor phone">Investor phone</mat-option>
        </mat-select>
        <button *ngIf="searchForm.isEmpty" type="button" mat-icon-button matSuffix (click)="searchForm.isEmpty = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showCategory">
        <mat-label>Category</mat-label>
        <mat-select [(ngModel)]="searchForm.category" name="category" placeholder="Category" (ngModelChange)="onCategoryChanged()" [disabled]="isCategoryLocked">
          <mat-option [value]="1">Auditing</mat-option>
          <mat-option [value]="2">Corporate governance</mat-option>
          <mat-option [value]="3">ESG</mat-option>
          <mat-option [value]="4">Voting results</mat-option>
          <mat-option [value]="5">Compensation</mat-option>
          <mat-option [value]="6">Accounting</mat-option>
        </mat-select>
        <button *ngIf="searchForm.category !== undefined && searchForm.category !== null" type="button" mat-icon-button matSuffix (click)="onCategoryCleared(); $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showFinished">
        <mat-label>Finished</mat-label>
        <mat-select [(ngModel)]="searchForm.finished" name="finished" placeholder="Finished" [disabled]="searchForm.category === undefined || searchForm.category === null">
          <mat-option value="all">All</mat-option>
          <mat-option value="yes">Yes</mat-option>
          <mat-option value="no">No</mat-option>
        </mat-select>
        <button *ngIf="searchForm.finished" type="button" mat-icon-button matSuffix (click)="searchForm.finished = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showChecked">
        <mat-label>Checked</mat-label>
        <mat-select [(ngModel)]="searchForm.checked" name="checked" placeholder="Checked" [disabled]="searchForm.category === undefined || searchForm.category === null">
          <mat-option value="all">All</mat-option>
          <mat-option value="yes">Yes</mat-option>
          <mat-option value="no">No</mat-option>
        </mat-select>
        <button *ngIf="searchForm.checked" type="button" mat-icon-button matSuffix (click)="searchForm.checked = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="fill" *ngIf="fieldsConfig.showIsin">
        <mat-label>ISIN</mat-label>
        <input matInput [(ngModel)]="searchForm.isin" name="isin" placeholder="Search by company ISIN">
      </mat-form-field>
      <div *ngIf="fieldsConfig.showIsActive" class="checkbox-field">
        <mat-checkbox [(ngModel)]="searchForm.isActive" name="isActive">Is Active</mat-checkbox>
      </div>
    </div>
    <div class="search-actions">
      <button mat-flat-button color="primary" type="submit">
        <mat-icon>search</mat-icon>
        Search
      </button>
      <button mat-flat-button type="button" class="nrg-error-flat-button"  (click)="clearSearch()">
        <mat-icon>clear</mat-icon>
        Clear
      </button>
    </div>
  </form>
</div>
